import IGrantsClient from './IGrantsClient';
import { GrantsGraphQLResponse, GrantsClientDependencies } from './types';
import IGraphQLService from '../../../services/graphQLService/IGraphQLService';
import ITenantHandlerService from '../../../services/tenantHandler/ITenantHandlerService';

export default class GrantsClient implements IGrantsClient {
  private graphQLService: IGraphQLService;
  private tenantHandlerService: ITenantHandlerService;

  constructor({
    graphQLService,
    tenantHandlerService
  }: GrantsClientDependencies) {
    this.graphQLService = graphQLService;
    this.tenantHandlerService = tenantHandlerService;
  }

  async getGrants(): Promise<GrantsGraphQLResponse> {
    const client = this.graphQLService?.getClient?.();
    if (!client?.query) return;

    const tenantId = this.tenantHandlerService?.getTenantId?.() || '';

    const query = `query Identity${tenantId.replace(/-/g, '')} {
         devices {
            items {
              grants {
                active { grant }
                pending { grant }
              }
              deviceId
            }
          }
          account {
            grants {
              active { grant }
              pending { grant }
            }
          }
      }`;

    const response = await client.query<
      GrantsGraphQLResponse,
      Record<string, unknown>
    >(query, null, { fetchPolicy: 'no-cache' });

    return response?.data as GrantsGraphQLResponse;
  }
}
